export default "__VITE_ASSET__BZNY4oDh__"